import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import cookies from 'js-cookie';
import { AkamaiCookie } from '../utils/akamaiCookies';
import * as locationParser from '../zipcode-service/utils/locationParser';
export default function queueCoxAutoDataLayer(_x) {
  return _queueCoxAutoDataLayer.apply(this, arguments);
}
function _queueCoxAutoDataLayer() {
  _queueCoxAutoDataLayer = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_ref) {
    var _googleanalytics$comm, _googleanalytics$comm2, _googleanalytics$comm3;
    var _ref$dataLayer, dataLayer, _ref$data, data, consumeradtargetswithoutcampdata, consumeradtargetsdata, consumermarketingsegmentsdata, consumerinsightsdata, editorial, _dataLayer$googleanal, googleanalytics, info, _dataLayer$mykbb, mykbb, syc, service, vehicleSearch, location, peIds, peAddedByRule, logInSource, akamaiLocation, commonDataLayer, _info$categories, ico, _peIds$ids, insights;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$dataLayer = _ref.dataLayer, dataLayer = _ref$dataLayer === void 0 ? {} : _ref$dataLayer, _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data;
          globalThis.coxAutoDataLayer = globalThis.coxAutoDataLayer || [];
          consumeradtargetswithoutcampdata = dataLayer.consumeradtargetswithoutcampdata, consumeradtargetsdata = dataLayer.consumeradtargetsdata, consumermarketingsegmentsdata = dataLayer.consumermarketingsegmentsdata, consumerinsightsdata = dataLayer.consumerinsightsdata, editorial = dataLayer.editorial, _dataLayer$googleanal = dataLayer.googleanalytics, googleanalytics = _dataLayer$googleanal === void 0 ? {} : _dataLayer$googleanal, info = dataLayer.info, _dataLayer$mykbb = dataLayer.mykbb, mykbb = _dataLayer$mykbb === void 0 ? {} : _dataLayer$mykbb, syc = dataLayer.syc, service = dataLayer.service, vehicleSearch = dataLayer.vehicleSearch, location = dataLayer.location, peIds = dataLayer.peIds, peAddedByRule = dataLayer.peAddedByRule;
          logInSource = cookies.get('MyConsumerSignedIn') || 0;
          akamaiLocation = locationParser.decodeAsAkami(cookies.get(AkamaiCookie));
          commonDataLayer = {
            page: {
              hierarchy: [(_googleanalytics$comm = googleanalytics.common) === null || _googleanalytics$comm === void 0 || (_googleanalytics$comm = _googleanalytics$comm.page) === null || _googleanalytics$comm === void 0 ? void 0 : _googleanalytics$comm.siteSection, (_googleanalytics$comm2 = googleanalytics.common) === null || _googleanalytics$comm2 === void 0 || (_googleanalytics$comm2 = _googleanalytics$comm2.page) === null || _googleanalytics$comm2 === void 0 ? void 0 : _googleanalytics$comm2.pageType, (_googleanalytics$comm3 = googleanalytics.common) === null || _googleanalytics$comm3 === void 0 || (_googleanalytics$comm3 = _googleanalytics$comm3.page) === null || _googleanalytics$comm3 === void 0 ? void 0 : _googleanalytics$comm3.detailPageName]
            },
            user: {
              isInternalUser: String(!!mykbb.isInternalUser),
              logInSource: String(logInSource),
              zipCode: akamaiLocation === null || akamaiLocation === void 0 ? void 0 : akamaiLocation.akamaizip
            },
            search: {
              zipCode: location === null || location === void 0 ? void 0 : location.zip
            },
            peSnapshotId: null
          };
          if (syc) {
            commonDataLayer.syc = {
              purchaseOrEditPath: syc.purchasePath,
              orderId: syc.orderId
            };
          }
          if (service) {
            commonDataLayer.service = {
              customerSource: service.customerSource
            };
          }
          if (info) {
            commonDataLayer.vehicle = {
              bodyStyleGroup: info.type,
              descriptionExists: info.description,
              driveTrain: info.driveTrain,
              fuelType: info.fuelType,
              legacyConfigurationId: info.vehicleId,
              productConfiguration: info.productConfiguration,
              sellerType: info.sellerType,
              seriesId: info.seriesId,
              subCategory: info === null || info === void 0 || (_info$categories = info.categories) === null || _info$categories === void 0 || (_info$categories = _info$categories.sub) === null || _info$categories === void 0 ? void 0 : _info$categories.code,
              transmission: info.transmission,
              trimId: info.trimId,
              vin: info.vin,
              licensePlate: info.licensePlate
            };
          }
          if (vehicleSearch) {
            commonDataLayer.vehicleSearch = {
              searchKeywords: vehicleSearch.searchKeywords,
              vehicleHistory: vehicleSearch.vehicleHistory,
              vehicleSellerType: vehicleSearch.vehicleSellerType,
              atHomeVehicleServices: vehicleSearch.atHomeVehicleServices
            };
          }
          if (googleanalytics.ico) {
            ico = googleanalytics.ico;
            commonDataLayer.ico = {
              offerCode: ico.offerCode,
              optionToSell: ico.optionToSell,
              entryPoint: ico.entryPoint,
              responseFields: ico.responseFields,
              responseValues: ico.responseValues,
              path: ico.path,
              offerStatus: ico.offerStatus,
              filterResults: ico.filterResults,
              searchDetails: ico.searchDetails,
              profileId: ico.profileID,
              vehicleEntry: ico.vehicleEntry,
              offerId: ico.offerId
            };
          }
          if (editorial) {
            commonDataLayer.editorial = {
              author: editorial.author,
              modifiedDate: editorial.modifiedDate,
              publishedDate: editorial.publishedDate,
              searchKeywords: editorial.searchKeywords
            };
          }
          if (consumerinsightsdata !== null && consumerinsightsdata !== void 0 && consumerinsightsdata.insights) {
            insights = consumerinsightsdata.insights;
            commonDataLayer.consumerInsights = {
              apiTrackingId: peIds === null || peIds === void 0 || (_peIds$ids = peIds.ids) === null || _peIds$ids === void 0 ? void 0 : _peIds$ids.peTrackingId,
              fixedOps: insights.fixedOps,
              makeBodystyleLoyalty: insights.makeBodystyleLoyalty,
              marketLevel: insights.marketLevel,
              marketLevelConfidence: insights.marketLevelConfidence,
              preferredBodystyle: insights.preferredBodystyle,
              preferredBodystyleConfidence: insights.preferredBodystyleConfidence,
              preferredMake: insights.preferredMake,
              preferredMakeConfidence: insights.preferredMakeConfidence,
              preferredMileage: insights.preferredMileage,
              preferredMileageConfidence: insights.preferredMileageConfidence,
              preferredModel: insights.preferredModel,
              preferredModelConfidence: insights.preferredModelConfidence,
              preferredPrice: insights.preferredPrice,
              preferredPriceConfidence: insights.preferredPriceConfidence,
              preferredVehicleType: insights.preferredVehicleType,
              preferredVehicleTypeConfidence: insights.preferredVehicleTypeConfidence,
              priceSensitivity: insights.priceSensitivity,
              recentActivityPreferredMake: insights.recentActivityPreferredMake,
              recentActivityPreferredModel: insights.recentActivityPreferredModel,
              secondPreferredFuelCategory: insights.secondPreferredFuelCategory,
              secondPreferredMake: insights.secondPreferredMake,
              secondPreferredModel: insights.secondPreferredModel
            };
          }
          if (consumermarketingsegmentsdata) {
            commonDataLayer.consumerMarketingSegments = {
              demographics: consumermarketingsegmentsdata.demographics,
              lifeevents: consumermarketingsegmentsdata.lifeEvents,
              clusters: consumermarketingsegmentsdata.clusters
            };
          }
          if (consumeradtargetswithoutcampdata) {
            commonDataLayer.consumerAdTargetsWithoutCAMPBias = {
              preferredModel: consumeradtargetswithoutcampdata.preferredModel,
              secondPreferredModel: consumeradtargetswithoutcampdata.secondPreferredModel,
              preferredMakes: consumeradtargetswithoutcampdata.preferredMakes,
              subCategory: consumeradtargetswithoutcampdata.subCategory,
              intent: consumeradtargetswithoutcampdata.intent,
              tradeInMake: consumeradtargetswithoutcampdata.tradeInMake,
              tradeInModel: consumeradtargetswithoutcampdata.tradeInModel
            };
          }
          if (consumeradtargetsdata) {
            commonDataLayer.consumerAdTargets = {
              consumerAdTargetInsightsAvailable: consumeradtargetsdata.targetInsightsAvailable,
              consumerCampaignPreferencesAddedByRule: peAddedByRule
            };
          }
          globalThis.coxAutoDataLayer.push(commonDataLayer);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _queueCoxAutoDataLayer.apply(this, arguments);
}